import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Home from './Home';
import MainForm from './MainForm';
import ResetPasswordForm from './ResetPasswordForm';
import ActivationForm from './ActivationForm';
import LoginNavButtons from './LoginNavButtons';
import SideBar from './SideBar';
import Steps from './steps';
import Styles from './index.module.css';

export default function SignIn() {
  const [step, setStep] = useState(Steps.Login);
  const [resetPasswordEmail, setResetPasswordEmail] = useState('');
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname !== '/password-reset') return;

    const params = new URLSearchParams(location.search);
    const email = params.get('email');
    if (!email) {
      history.push('/Register');
      return;
    }

    setResetPasswordEmail(email);
    setStep(Steps.ResetPassword);
  }, [location.pathname, location.search]);

  return (
    <div className={Styles.mainContainer}>
      <div className={Styles.container} style={{ maxWidth: 1300, width: '100%' }}>
        <SideBar step={step} onChangeStep={setStep} />
        <div className={Styles.InfoRow}>
          <div className={Styles.formPart}>
            {[Steps.Register, Steps.Login].includes(step)
            && <MainForm step={step} onChangeStep={setStep} />}
            {[Steps.ForgotPassword, Steps.ResetPassword].includes(step)
            && (
              <ResetPasswordForm
                step={step}
                onChangeStep={setStep}
                onChangeResetPasswordEmail={setResetPasswordEmail}
                resetPasswordEmail={resetPasswordEmail}
              />
            )}
            {step === Steps.ActivateAccount && <ActivationForm onChangeStep={setStep} />}
            {step === Steps.Home && <Home />}
          </div>
        </div>
        <LoginNavButtons step={step} onChangeStep={setStep} />
      </div>
    </div>
  );
}
